import ErrorAlertModal from './ErrorAlertModal';

export default ErrorAlertModal;
